import { Injectable } from '@angular/core';
import { AlertController, NavController, Platform } from '@ionic/angular';
import { Subject, Observable } from 'rxjs';
import { ConfigProvider } from '../config/config';
import { EventProvider, EventDetailsModel, MyEventListModel } from '../event/event';
import { ResultProvider, ResultListModel } from '../result/result';
import { UserProvider, MySportProfileListItem } from '../user/user';
import { NewsProvider } from '../news/news';
import { IFirebaseService } from '../../core/services/firebase/firebase.service.interface';
import { FirebaseServiceFactory } from '../../core/services/firebase/firebase.factory';

@Injectable()
export class NotificationProvider {

  private token: string = null;
  public registration: Subject<string>[] = [];
  private recive: Subject<any>[] = [];
  private firebaseService: IFirebaseService;

  constructor(
    private platform: Platform,
    private firebaseServiceFactory: FirebaseServiceFactory,
    private eventService: EventProvider,
    private resultService: ResultProvider,
    private userService: UserProvider,
    private newsService: NewsProvider,
    private alertCtrl: AlertController,
    private navCtrl: NavController
  ) {
    this.firebaseService = this.firebaseServiceFactory.create();
    this.init();
  }

  private async init() {
    await this.platform.ready();
    await this.initFirebase();
  }

  private async initFirebase() {
    try {
      this.token = await this.firebaseService.getToken();
      console.log('Firebase token received:', this.token);
      if(this.token) this.registration.forEach(reg => reg.next(this.token));
      this.firebaseService.onMessageReceived().subscribe(notification => {
        console.log('Notification received:', notification);
        this.handleNotificationReceived(notification);
      });

      this.firebaseService.onTokenRefresh().subscribe(token => {
        console.log('Firebase token refreshed:', token);
        this.token = token;
      });
    } catch (error) {
      console.error('Firebase initialization failed:', error);
    }
  }

  private handleNotificationReceived(notification: any) {
    this.recive.forEach(rec => rec.next(notification));
  }

  async getNotificationToken(): Promise<string> {
    return this.token;
  }

  public register(): Promise<string> {
    return Promise.resolve(this.token);
  }

  public onRegistration(): Observable<string> {
    const sub = new Subject<string>();
    if (this.token) {
      sub.next(this.token);
    } else {
      this.registration.push(sub);
    }
    return sub.asObservable();
  }

  public onRecive(): Observable<any> {
    const sub = new Subject<any>();
    this.recive.push(sub);
    return sub.asObservable();
  }

  public handleNotification(notification: any) {
    const data = notification || notification.aps;
    console.log('handleNotification', JSON.stringify(data))
    if (!data?.Page) return;

    switch (data.Page) {
      case "Event":
        if (data.Id) {
          this.eventService.getEventDetails(data.Id).then((event: EventDetailsModel) => {
            
            // (this.app.getRootNav() as NavController).push(EventTabsPage, { event });
            this.navCtrl.navigateForward('/event/tabs', {state:{event}});
          });
        }
        break;

      case "Result":
        if (data.Id) {
          this.resultService.getResult(data.Id).then((result: ResultListModel) => {
            // this.app.getRootNav().push(ResultDetailsPage, { result });
            this.navCtrl.navigateForward('/result-details', {state:{result}});
          });
        }
        break;

      case "Ranglist":
        if (data.Id) {
          const searchModel = { eid: "" + data.Id, ename: "", limit: "25", page: "1", start: "0" };
          this.resultService.getRangList(searchModel).then(list => {
            this.navCtrl.navigateForward('/result-ranglist', {state:{data: { list, search: searchModel }}});
            // this.app.getRootNav().push(ResultRanglistPage, { data: { list, search: searchModel } });
          });
        }
        break;

      case "MyPhotos":
        this.userService.getMyPhotos().then(pictures => {
          // this.app.getRootNav().push(MysportPhotosPage, { pictures });
          this.navCtrl.navigateForward('/mysport-photos', {state:{pictures}});
        });
        break;

      case "MyResults":
        this.userService.getMyResults().then(results => {
          // this.app.getRootNav().push(MysportResultsPage, { results });
          this.navCtrl.navigateForward('/mysport-results', {state:{results}});
        });
        break;

      case "MyEvents":
        this.eventService.getMyEvents().then(events => {
          // this.app.getRootNav().push(MysportEventsPage, { data: events });
          this.navCtrl.navigateForward('/mysport-event', {state:{data: events}});
        });
        break;

      case "MyFriends":
        this.userService.getMyFriends().then(friendList => {
          this.userService.getMyFans().then(fanList => {
            this.navCtrl.navigateForward('/MysportContactsPage', {state:{friendList, fanList, page: "friends"}});
            // this.app.getRootNav().push(MysportContactsPage, { friendList, fanList, page: "friends" });
          });
        });
        break;

      case "MyFans":
        this.userService.getMyFriends().then(friendList => {
          this.userService.getMyFans().then(fanList => {
            this.navCtrl.navigateForward('/MysportContactsPage', {state:{friendList, fanList, page: "fans"}});
            // this.app.getRootNav().push(MysportContactsPage, { friendList, fanList, page: "fans" });
          });
        });
        break;

      case "News":
        if (data.Id) {
          this.newsService.getNews(data.Id).then(news => {
            this.navCtrl.navigateForward('/NotificationDetailsPage', {state:{news}});
            // this.app.getRootNav().push(NotificationDetailsPage, { news });
          });
        }
        break;

      default:
        break;
    }
  }
}
